module.exports = __webpack_public_path__ + "assets/38ab52cd2dff7d18577e0647edf65aa2.mp3";